<template>
  <div>
    <QuoteHeader :quoteId="quoteId" />
    <v-container fluid>
      <div v-if="!isQuoteLoaded" class="quote-boot-placeholder">
        <v-progress-linear indeterminate color="primary" class="mb-3" />
        <div class="caption grey--text text-center">Loading quote…</div>
      </div>
      <!-- Keep light tabs cached; exclude Program (huge DOM / image bitmaps). -->
      <keep-alive :max="4" exclude="QuoteProgram">
        <router-view v-if="isQuoteLoaded" />
      </keep-alive>
      <div v-if="isQuoteLoaded && refreshing" class="quote-refresh-bar">
        <v-progress-linear indeterminate height="2" color="primary" />
      </div>
    </v-container>
  </div>
</template>

<script>
import { QuoteHeader } from "@/modules/quotes";
export default {
  components: {
    QuoteHeader,
  },
  data() {
    return {
      isQuoteLoaded: false,
      refreshing: false,
    };
  },
  computed: {
    quoteId() {
      return this.$route.params.quote_id;
    },
    cachedQuoteId() {
      return this.$store.getters["QuoteStore/quote_id"] || this.$store.getters["QuoteStore/active"]?.id || null;
    },
  },
  watch: {
    quoteId(next, prev) {
      if (next && next !== prev) this.loadQuote({ quiet: false });
    },
  },
  mounted() {
    this.$store.commit("QuoteStore/CLEAR_QUOTE_SNAPSHOT");
    window.addEventListener("beforeunload", this.onBeforeUnload);
    window.addEventListener("pageshow", this.onPageShow);
    document.addEventListener("visibilitychange", this.onVisibilityChange);

    const quiet = this.cachedQuoteId && String(this.cachedQuoteId) === String(this.quoteId);
    if (quiet) this.isQuoteLoaded = true;
    this.loadQuote({ quiet });
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
    window.removeEventListener("pageshow", this.onPageShow);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },
  methods: {
    loadQuote({ quiet = false } = {}) {
      if (!this.quoteId) return Promise.resolve();

      if (quiet) {
        this.refreshing = true;
      } else {
        this.isQuoteLoaded = false;
        this.$root.$loading?.open("Loading quote...");
      }

      return this.$store
        .dispatch("QuoteStore/getOneQuote", this.quoteId)
        .finally(() => {
          this.isQuoteLoaded = true;
          this.refreshing = false;
          this.$root.$loading?.end();
          this.$nextTick(() => {
            this.$store.commit("QuoteStore/SAVE_QUOTE_SNAPSHOT");
            this.$root.$emit("quote-refreshed", this.quoteId);
          });
        });
    },
    onBeforeUnload(event) {
      if (!this.$store.getters["QuoteStore/hasUnsavedChanges"]) return;
      event.preventDefault();
      event.returnValue = "";
    },
    onPageShow(event) {
      // Restored from back-forward cache: refresh quietly so content stays on screen.
      if (event.persisted && this.isQuoteLoaded) {
        this.loadQuote({ quiet: true });
      }
    },
    onVisibilityChange() {
      if (document.visibilityState !== "visible" || !this.isQuoteLoaded) return;
      // If Chrome discarded memory for related assets, child views re-hydrate via quote-refreshed
      // only when we actually refetch. Skip automatic refetch on every tab focus to avoid churn.
    },
  },
};
</script>

<style lang="scss">
.quote-boot-placeholder {
  padding: 48px 16px;
  max-width: 480px;
  margin: 0 auto;
}

.quote-refresh-bar {
  position: sticky;
  top: 0;
  z-index: 5;
}

.booking-wrapper {
  height: calc(100% - 48px);

  .booking-title {
    padding: 2px 5px 0;
    background: lightgrey;
    font-weight: 500;
    font-size: 12px;
  }
}
</style>
